import { SUBPROCESSORS } from "../lib/subprocessors";

export function SubprocessorTable({ showData = true }: { showData?: boolean }) {
  return (
    <table aria-label="Subprocessors" className="w-full border-collapse text-sm">
      <thead>
        <tr className="border-b border-slate-200 text-left">
          <th className="py-2 pr-4 font-medium text-slate-900">Subprocessor</th>
          <th className="py-2 pr-4 font-medium text-slate-900">Purpose</th>
          {showData && <th className="py-2 pr-4 font-medium text-slate-900">Data shared</th>}
          <th className="py-2 font-medium text-slate-900">Region</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100">
        {SUBPROCESSORS.map((s) => (
          <tr key={s.name}>
            <td className="py-2 pr-4 font-medium text-slate-900">{s.name}</td>
            <td className="py-2 pr-4">{s.purpose}</td>
            {showData && <td className="py-2 pr-4">{s.data}</td>}
            <td className="py-2"><code>{s.region}</code></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
